import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/style.css";
import FirebaseContext from "../firebase/firebaseContext";

const Navbar = (props) => {
	const firebaseContext = useContext(FirebaseContext);
	const [user, setUser] = useState(false);
	const { auth } = firebaseContext;

	useEffect(() => {
		auth.onAuthStateChanged((user) => {
			if (
				user.uid === "OT9bl4yHkMb5x7kihRxiNL4TM6x2" ||
				user.uid === "TikPJxf69bgC5nheDQ9ymuWEd4r1" ||
				user.uid === "dK1ecPHQYwXrgC526YjZWlzmrdk2"
			) {
				setUser(true);
			}
		});
	}, []);
	const logout = async (e) => {
		e.preventDefault();
		await auth.signOut();
	};

	return (
		<header className='header'>
			<h1 className='logo'>
				<Link to='/'>English - bicevje</Link>
			</h1>
			<ul className='main-nav'>
				{user && (
					<li>
						<Link to='/ucenci'>Učenci</Link>
					</li>
				)}
				{user && (
					<li>
						<Link to='/create'>Dodaj uro</Link>
					</li>
				)}
				{user && (
					<li>
						<Link to='/createExercise'>Dodaj vajo</Link>
					</li>
				)}
				<li>
					<Link to='/naloge'>Učne ure</Link>
				</li>

				<li>
					<Link to='/ucenec'>ZVEZEK</Link>
				</li>
				<li>
					<Link
						to='/ocenjevanje'
						style={{ color: "purple", fontWeight: "400" }}
					>
						OCENJEVANJE
					</Link>
				</li>

				<li>
					<Link to='/login'>
						<button>Vpiši se</button>
					</Link>
				</li>
				<li
					style={{ fontSize: "1rem", cursor: "pointer" }}
					onClick={(e) => logout(e)}
				>
					Izpis
				</li>
			</ul>
		</header>
	);
};

export default Navbar;
